import jwtAuthAxios from "./auth/jwtAuth";

const orderServices = {};

orderServices.getOrders = async (params) => {
    const {data} = await jwtAuthAxios.get(`/orders${params}`);
    return data;
};

// Tipos de documento que tiene la compañia actual, para el filtro de Pedidos.
// Fotos de los bultos sacadas en la app al pickear, con quien y cuando.
orderServices.getPackagePhotos = async (order_id) => {
    const {data} = await jwtAuthAxios.get(`/orders/${order_id}/package_photos`);
    return data;
};

orderServices.getDocumentTypes = async () => {
    const {data} = await jwtAuthAxios.get(`/orders/document_types`);
    return data;
};

// Origenes que la compañia tiene en algun pedido, para el filtro "Origen".
orderServices.getSources = async () => {
    const {data} = await jwtAuthAxios.get(`/orders/sources`);
    return data;
};

// Hasta 10 productos por codigo o nombre, para el pedido creado a mano.
orderServices.getProductOptions = async (q) => {
    const {data} = await jwtAuthAxios.get(`/orders/product_options`, { params: q ? { q } : {} });
    return data?.products || [];
};

orderServices.getOrder = async (id) => {
    const {data} = await jwtAuthAxios.get(`/orders/${id}`);
    return data;
};

orderServices.updateOrder = async (id, payload) => {
    const {data} = await jwtAuthAxios.put(`/orders/${id}`, { order: payload });
    return data;
};

orderServices.assignPreparer = async (id, preparerId) => {
    try {
        const {data} = await jwtAuthAxios.post(`/orders/${id}/assign_preparer`, { preparer_id: preparerId });
        return data;
    } catch (error) {
        console.error("Error assigning preparer:", error);
        return error.response ? error.response.data : error.message;
    }
}

orderServices.syncRemoteOrder = async (id) => {
    const {data} = await jwtAuthAxios.get(`/orders/${id}/sync_with_remote`);
    return data;
}

orderServices.bulkImport = async (files) => {
    const formData = new FormData();
    for (const file of files) {
        formData.append('files[]', file);
    }

    const {data} = await jwtAuthAxios.post(`/orders/bulk_import`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return data;
}

orderServices.createOrder = async (orderData, orderDetailsList) => {
    const { data } = await jwtAuthAxios.post(`/orders`, {
        order: orderData,
        order_details: orderDetailsList
    });
    return data;
};

orderServices.replacePreparer = async (orderId, preparerId) => {
    const { data } = await jwtAuthAxios.post(
        `/orders/${orderId}/replace_preparer`,
        { preparer_id: preparerId }
    );
    return data;
};

// Despacho de un pedido de ML "acordar con el vendedor": { mode, address, carrier, rut, phone }.
// Calendario de pedidos (Orders::Calendar). Sin `detail`, conteos por dia: { days }. Con
// `detail: true`, los pedidos del rango: { orders }. `q` son los mismos filtros de Pedidos.
orderServices.getCalendar = async ({ from, to, detail = false, q = {} }) => {
    // Axios 0.x manda un objeto anidado como JSON: se aplana a q[campo] para ransack.
    const filtros = Object.fromEntries(Object.entries(q).filter(([, v]) => v).map(([k, v]) => [`q[${k}]`, v]));
    const { data } = await jwtAuthAxios.get('/orders/calendar', { params: { from, to, detail, ...filtros } });
    return data;
};

// Reprogramar un pedido arrastrandolo a otro dia del calendario.
orderServices.moveInCalendar = async (id, shipDate) => {
    const { data } = await jwtAuthAxios.post('/orders/calendar_move', { id, ship_date: shipDate });
    return data;
};

// Boton "Acciones" de Pedidos: la misma accion sobre varios pedidos. Devuelve
// { ok: <cuantos>, failed: [{ id, code, error }] }.
orderServices.bulkAction = async (action, orderIds, params = {}) => {
    const { data } = await jwtAuthAxios.post('/orders/bulk_action', { bulk_action: action, order_ids: orderIds, params });
    return data;
};

orderServices.setAgreedShipping = async (orderId, payload) => {
    const { data } = await jwtAuthAxios.post(`/orders/${orderId}/agreed_shipping`, payload);
    return data;
};

orderServices.setDropoff = async (orderId, payload) => {
    try {
        const { data } = await jwtAuthAxios.post(
            `/orders/${orderId}/set_dropoff`,
            payload
        );
        return data;
    } catch (error) {
        console.error("Error setting dropoff:", error);
        return error.response ? error.response.data : error.message;
    }
};

// Eliminar un pedido. Del lado del backend es una eliminacion logica -el pedido pasa a
// estado 'deleted' y queda guardado quien lo elimino-, pero para el listado es un DELETE
// comun: el pedido deja de poder tocarse.
//
// El error se deja subir en vez de devolverlo como dato: el que llama necesita distinguir
// un 403 (perfil sin permiso) de un 422 (pedido en progreso o finalizado) para decir cual
// de las dos cosas paso.
orderServices.deleteOrder = async (orderId) => {
    const { data } = await jwtAuthAxios.delete(`/orders/${orderId}`);
    return data;
};

// Plan Distribuidor. Devuelve el pedido serializado; el error sube para mostrar su mensaje.
orderServices.updateManualState = async (orderId, state) => {
    const { data } = await jwtAuthAxios.post(`/orders/${orderId}/manual_state`, { state });
    return data;
};

// Plan Distribuidor: arma el viaje que ve la app movil. El error sube para mostrar su mensaje.
orderServices.sendToPreparation = async (body) => {
    const { data } = await jwtAuthAxios.post('/orders/send_to_preparation', body);
    return data;
};

orderServices.cancelForTrip = async (orderId, tripId) => {
    const { data } = await jwtAuthAxios.post(
        `/orders/${orderId}/cancel_for_trip`,
        { trip_id: tripId }
    );
    return data;
};

// orderServices.saveRecipients = async (id, params) => {
//     const {data} = await jwtAuthAxios.post(`/orders/${id}/recipients`, params);
//     return data;
// };

// orderServices.saveCustomerGeofence = async (id, params) => {
//     const {data} = await jwtAuthAxios.post(`/orders/${id}/geofence`, params);
//     return data;
// };

// orderServices.getReceiptsPins = async (id) => {
//     const {data} = await jwtAuthAxios.get(`/orders/${id}/receipts_pins`);
//     return data;
// };

orderServices.fetchShipmentLabels = async (orderIds) => {
    const response = await jwtAuthAxios.post('/meli/shipment_labels',
        { order_ids: orderIds },
        { responseType: 'blob' }
    );
    return response.data;
};

orderServices.fetchShipmentLabelsZpl = async (orderIds) => {
    const response = await jwtAuthAxios.post('/meli/shipment_labels?print_format=zpl',
        { order_ids: orderIds },
        { responseType: 'text' }
    );
    return response.data;
};

// Etiqueta propia de Haulers. El preflight dice qué datos tiene el pedido y qué
// falta (típicamente el RUT, que Shopify no manda), así el diálogo sabe qué pedir
// antes de imprimir.
orderServices.getHaulersLabelPreflight = async (orderId) => {
    const { data } = await jwtAuthAxios.get(`/orders/${orderId}/haulers_label`);
    return data;
};

// Crea los bultos con su token y devuelve el ZPL (una etiqueta por bulto).
// printer_id define el papel: el ancho y el largo del ZPL salen de esa impresora.
// comuna y region son las corregidas en el diálogo; el backend las imprime y las
// guarda en la dirección del cliente.
//
// Ojo: se manda el objeto completo en vez de desestructurar campo por campo. Con
// la desestructuración, agregar un campo en el diálogo y olvidarse de agregarlo
// acá lo descarta en silencio — pasó con comuna y region, y solo se notó cuando
// salió una etiqueta impresa con la comuna sin corregir.
orderServices.createHaulersLabel = async (orderId, payload) => {
    const { data } = await jwtAuthAxios.post(`/orders/${orderId}/haulers_label`, payload);
    return data;
};

// Datos del remitente de la etiqueta Haulers: se guardan una vez por empresa.
orderServices.updateHaulersLabelSender = async (remitente) => {
    const { data } = await jwtAuthAxios.put(`/haulers_label/remitente`, { remitente });
    return data;
};

orderServices.fetchBluexpressLabels = async (orderIds) => {
    const response = await jwtAuthAxios.post('/bluexpress/shipment_labels',
        { order_ids: orderIds },
        { responseType: 'blob' }
    );
    return response.data;
};
export default orderServices;
